/* eslint-disable @typescript-eslint/naming-convention */
export enum ExpressItemLimitSource {
	ReviewOrder = 'review-order',
	Trolley = 'trolley',
	Shop = 'shop',
	OrderValidation = 'order-validation',
}
